import React, { useEffect, useState } from "react";
import axios from "axios";
import "../styles/nortification.css";

function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const userId = localStorage.getItem("userId");

  const fetchData = () => {
    axios
      .get(`http://localhost:5000/api/notifications?user_id=${userId}`)
      .then((res) => setNotifications(res.data));
  };

  useEffect(() => {
    if (!userId) return;
    fetchData();
  }, [userId]);

  // 🔔 UNREAD COUNT
  const unreadCount = notifications.filter(n => n.is_read === 0).length;

  // ✅ MARK AS READ ON CLICK
  const handleClick = async (id) => {
    await axios.put(`http://localhost:5000/api/notifications/read/${id}`);

    setNotifications((prev) =>
      prev.map((n) =>
        n.id === id ? { ...n, is_read: 1 } : n
      )
    );
  };

  return (
    <div className="notification-page">

      {/* HEADER WITH BELL ICON */}
      <div className="notification-header">

        <h2>
          Notifications 🔔
          {unreadCount > 0 && (
            <span className="badge-count">{unreadCount}</span>
          )}
        </h2>

        <p>Click notification to mark as read</p>
      </div>

      {/* LIST */}
      <div className="notification-container">

        {notifications.length === 0 ? (
          <div className="empty-state">
            <div className="icon">🔔</div>
            <p>No notifications</p>
          </div>
        ) : (
          notifications.map((n) => (
            <div
              key={n.id}
              className={`notification-card ${n.is_read ? "read" : "unread"}`}
              onClick={() => handleClick(n.id)}
            >

              <div className="notification-top">
                <span className="badge">{n.type || "Info"}</span>

                {!n.is_read && <span className="unread-dot"></span>}

                <span className="time">
                  {new Date(n.created_at).toLocaleString()}
                </span>
              </div>

              <div className="message">{n.message}</div>

              <div className="notification-footer">
                <span>From: {n.sender_id || "System"}</span>
                <span>To: {n.receiver_id || n.user_id}</span>
              </div>

            </div>
          ))
        )}

      </div>
    </div>
  );
}

export default Notifications;